// Plan configurations for both basic and advanced pricing modes
export const plans = [
  {
    id: "freelance",
    name: "Freelance",
    priceMonthly: 80,
    priceYearly: 800,
    maxSocialAccounts: 5,
    maxUsers: 1,
    maxSources: 5,
    features: {
      native: false,
      planification: false,
      moderation: false,
      reporting: false,
      collaboration: false,
    },
  },
  {
    id: "starter",
    name: "Starter",
    priceMonthly: 170,
    priceYearly: 1700,
    maxSocialAccounts: 10,
    maxUsers: 5,
    maxSources: 10,
    features: {
      native: true,
      planification: true,
      moderation: true,
      reporting: true,
      collaboration: true,
    },
  },
  {
    id: "standard",
    name: "Standard",
    priceMonthly: 270,
    priceYearly: 2700,
    maxSocialAccounts: 60,
    maxUsers: 50,
    maxSources: 60,
    features: {
      native: true,
      planification: true,
      moderation: true,
      reporting: true,
      collaboration: true,
    },
  },
  {
    id: "premium",
    name: "Premium",
    priceMonthly: 600,
    priceYearly: 6000,
    maxSocialAccounts: 250,
    maxUsers: 200,
    maxSources: 250,
    features: {
      native: true,
      planification: true,
      moderation: true,
      reporting: true,
      collaboration: true,
    },
  },
  {
    id: "custom",
    name: "Contactez-nous",
    priceMonthly: null,
    priceYearly: null,
    maxSocialAccounts: 251,
    maxUsers: 201,
    maxSources: 251,
    features: {
      native: true,
      planification: true,
      moderation: true,
      reporting: true,
      collaboration: true,
    },
  },
]

// Plans available in basic mode (without freelance)
export const plansBasic = plans.filter((plan) => plan.id !== "freelance")

// Features labels for display
export const featureLabels = {
  native: "Connexion Native",
  planification: "Planifier vos publications",
  moderation: "Modération de vos réseaux",
  reporting: "Reporting de performances",
  collaboration: "Collaborer avec votre équipe",
}

export default plans
